var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAllCategoriesIcon = function SvgAllCategoriesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.75C13 17.1977 13.4477 16.75 14 16.75C14.5523 16.75 15 17.1977 15 17.75C15 18.3023 14.5523 18.75 14 18.75C13.4477 18.75 13 18.3023 13 17.75Z",
    fill: "#18181B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.75C16.5 17.1977 16.9477 16.75 17.5 16.75C18.0523 16.75 18.5 17.1977 18.5 17.75C18.5 18.3023 18.0523 18.75 17.5 18.75C16.9477 18.75 16.5 18.3023 16.5 17.75Z",
    fill: "#18181B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.25C13 5.69771 13.4477 5.25 14 5.25C14.5523 5.25 15 5.69771 15 6.25C15 6.80229 14.5523 7.25 14 7.25C13.4477 7.25 13 6.80229 13 6.25Z",
    fill: "#18181B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 20.75C13.25 20.3358 13.5858 20 14 20C14.4142 20 14.75 20.3358 14.75 20.75C14.75 21.1642 14.4142 21.5 14 21.5C13.5858 21.5 13.25 21.1642 13.25 20.75Z",
    fill: "#18181B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14C19.5 13.5858 19.8358 13.25 20.25 13.25C20.6642 13.25 21 13.5858 21 14C21 14.4142 20.6642 14.75 20.25 14.75C19.8358 14.75 19.5 14.4142 19.5 14Z",
    fill: "#18181B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10C19.5 9.58579 19.8358 9.25 20.25 9.25C20.6642 9.25 21 9.58579 21 10C21 10.4142 20.6642 10.75 20.25 10.75C19.8358 10.75 19.5 10.4142 19.5 10Z",
    fill: "#18181B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 3.25C13.25 2.83579 13.5858 2.5 14 2.5C14.4142 2.5 14.75 2.83579 14.75 3.25C14.75 3.66421 14.4142 4 14 4C13.5858 4 13.25 3.66421 13.25 3.25Z",
    fill: "#18181B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14C12.5 13.1716 13.1716 12.5 14 12.5C14.8284 12.5 15.5 13.1716 15.5 14C15.5 14.8284 14.8284 15.5 14 15.5C13.1716 15.5 12.5 14.8284 12.5 14Z",
    fill: "#18181B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10C12.5 9.17157 13.1716 8.5 14 8.5C14.8284 8.5 15.5 9.17157 15.5 10C15.5 10.8284 14.8284 11.5 14 11.5C13.1716 11.5 12.5 10.8284 12.5 10Z",
    fill: "#18181B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14C16.5 13.4477 16.9477 13 17.5 13C18.0523 13 18.5 13.4477 18.5 14C18.5 14.5523 18.0523 15 17.5 15C16.9477 15 16.5 14.5523 16.5 14Z",
    fill: "#18181B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10C16.5 9.44771 16.9477 9 17.5 9C18.0523 9 18.5 9.44771 18.5 10C18.5 10.5523 18.0523 11 17.5 11C16.9477 11 16.5 10.5523 16.5 10Z",
    fill: "#18181B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.25C16.5 5.69771 16.9477 5.25 17.5 5.25C18.0523 5.25 18.5 5.69771 18.5 6.25C18.5 6.80229 18.0523 7.25 17.5 7.25C16.9477 7.25 16.5 6.80229 16.5 6.25Z",
    fill: "#18181B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.25C11 6.80228 10.5523 7.25 10 7.25C9.44772 7.25 9 6.80228 9 6.25C9 5.69772 9.44772 5.25 10 5.25C10.5523 5.25 11 5.69772 11 6.25Z",
    fill: "#18181B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.25C7.5 6.80228 7.05228 7.25 6.5 7.25C5.94772 7.25 5.5 6.80228 5.5 6.25C5.5 5.69772 5.94772 5.25 6.5 5.25C7.05228 5.25 7.5 5.69772 7.5 6.25Z",
    fill: "#18181B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.75C11 18.3023 10.5523 18.75 10 18.75C9.44772 18.75 9 18.3023 9 17.75C9 17.1977 9.44772 16.75 10 16.75C10.5523 16.75 11 17.1977 11 17.75Z",
    fill: "#18181B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 3.25C10.75 3.66421 10.4142 4 10 4C9.58579 4 9.25 3.66421 9.25 3.25C9.25 2.83579 9.58579 2.5 10 2.5C10.4142 2.5 10.75 2.83579 10.75 3.25Z",
    fill: "#18181B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10C4.5 10.4142 4.16421 10.75 3.75 10.75C3.33579 10.75 3 10.4142 3 10C3 9.58579 3.33579 9.25 3.75 9.25C4.16421 9.25 4.5 9.58579 4.5 10Z",
    fill: "#18181B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14C4.5 14.4142 4.16421 14.75 3.75 14.75C3.33579 14.75 3 14.4142 3 14C3 13.5858 3.33579 13.25 3.75 13.25C4.16421 13.25 4.5 13.5858 4.5 14Z",
    fill: "#18181B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 20.75C10.75 21.1642 10.4142 21.5 10 21.5C9.58579 21.5 9.25 21.1642 9.25 20.75C9.25 20.3358 9.58579 20 10 20C10.4142 20 10.75 20.3358 10.75 20.75Z",
    fill: "#18181B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10C11.5 10.8284 10.8284 11.5 10 11.5C9.17157 11.5 8.5 10.8284 8.5 10C8.5 9.17157 9.17157 8.5 10 8.5C10.8284 8.5 11.5 9.17157 11.5 10Z",
    fill: "#18181B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14C11.5 14.8284 10.8284 15.5 10 15.5C9.17157 15.5 8.5 14.8284 8.5 14C8.5 13.1716 9.17157 12.5 10 12.5C10.8284 12.5 11.5 13.1716 11.5 14Z",
    fill: "#18181B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10C7.5 10.5523 7.05228 11 6.5 11C5.94772 11 5.5 10.5523 5.5 10C5.5 9.44772 5.94772 9 6.5 9C7.05228 9 7.5 9.44772 7.5 10Z",
    fill: "#18181B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14C7.5 14.5523 7.05228 15 6.5 15C5.94772 15 5.5 14.5523 5.5 14C5.5 13.4477 5.94772 13 6.5 13C7.05228 13 7.5 13.4477 7.5 14Z",
    fill: "#18181B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.75C7.5 18.3023 7.05228 18.75 6.5 18.75C5.94772 18.75 5.5 18.3023 5.5 17.75C5.5 17.1977 5.94772 16.75 6.5 16.75C7.05228 16.75 7.5 17.1977 7.5 17.75Z",
    fill: "#18181B"
  })));
};
export default SvgAllCategoriesIcon;